module.exports = __webpack_public_path__ + "static/media/box-spring-removal.746fdf52.svg";